import { css } from 'styled-components';

import { isDisabled, isFocused, isHovered, isNotDisabled } from 'design-system/lib/pseudoClass';
import { Variant } from 'design-system/theme';
import PseudoClassProps from 'design-system/types/PseudoClassProps';
import { Elevation } from 'design-system/variables/effect';
import { TransitionDuration } from 'design-system/variables/transitions';

interface HoverableMixinProps extends PseudoClassProps {
  variant?: Variant;
}

export const hoverMixin = css<HoverableMixinProps>`
  box-shadow:
    0 0 0 3px transparent,
    ${Elevation.Mid};
`;

export const focusMixin = (variantArg?: Variant) => css<HoverableMixinProps>`
  ${({ theme, variant = 'primary' }) => css`
    box-shadow: 0 0 0 3px ${theme.color.variants[variantArg || variant].highlight};
  `}
`;

export const hoverFocusMixin = (variantArg?: Variant) => css<HoverableMixinProps>`
  ${({ theme, variant = 'primary' }) => css`
    box-shadow:
      0 0 0 3px ${theme.color.variants[variantArg || variant].highlight},
      ${Elevation.Mid};
  `}
`;

/**
 * Adds an outline for a11y when focused, and a shadow when hovered.
 */
const hoverableMixin = css<HoverableMixinProps>`
  cursor: pointer;
  &${isDisabled} {
    cursor: not-allowed;
  }

  transition: box-shadow ${TransitionDuration.Fast};

  &${isHovered}${isNotDisabled} {
    ${hoverMixin};
  }
  &${isFocused}${isNotDisabled} {
    ${focusMixin()};
  }
  &${isHovered}${isFocused}${isNotDisabled} {
    ${hoverFocusMixin()};
  }
`;

export default hoverableMixin;
